/*
 * Copyright (c) 2018-Present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
import {connect} from 'react-redux';
import {useOktaAuth} from '@okta/okta-react';
import React, {useState, useEffect} from 'react';
import {useHistory} from 'react-router-dom';
import {incrementValue} from './redux/actions/example/exampleActions';
import {setCurrentUserId, setIsUserLoggedIn} from './redux/actions/uiActions';
import {getCurrentRegionAPIConfigs} from './components/utils/APIsUtils/httpsUtils';
const currentRegionAPIConfigs = getCurrentRegionAPIConfigs();

const Home = (props) => {
  const {setCurrentUserId, setIsUserLoggedIn} = props;
  const history = useHistory();
  const {authState, oktaAuth} = useOktaAuth();
  const [userInfo, setUserInfo] = useState(null);

  const createNewUser = async (oktaUserInfo) => {
    const oktaToken = JSON.parse(localStorage.getItem('okta-token-storage'));
    const {given_name = '', family_name = '', name = '', fullName = ''} = oktaUserInfo;
    const {idToken, accessToken} = oktaToken;
    const apiUrl = currentRegionAPIConfigs.baseURL + '/api/v1/users?isAdmin=true';
    await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        authorization: accessToken && accessToken.accessToken,
        profile: idToken && idToken.idToken,
      },
      body: JSON.stringify({
        firstName: given_name,
        lastName: family_name,
        name: fullName,
        partyId: name,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        history.push('/Dashboard');
        if (data && data.data) {
          const {amwayId} = data.data;
          if (amwayId) {
            setCurrentUserId(amwayId);
            window.localStorage.setItem('am_id', amwayId);
          }
        }
        window.location.reload();
      });
  };
  useEffect(() => {
    if (!authState || !authState.isAuthenticated) {
      // When user isn't authenticated, forget any user info
      setUserInfo(null);
      history.push('/login');
      window.location.reload();
    } else {
      setIsUserLoggedIn(true);
      oktaAuth
        .getUser()
        .then((info) => {
          setUserInfo(info);
          createNewUser(info);
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }, [authState, oktaAuth]); // Update if authState changes

  // const login = async () => {
  //   history.push("/login");
  // };

  // if (!authState) {
  //   return <div>Loading...</div>;
  // }

  return (
    <div
      style={{
        margin: '0 auto',
      }}
    >
      <div>Loading...</div>
      {/* <Header as="h1">PKCE Flow w/ Custom Login Page</Header> */}

      {/* {authState.isAuthenticated && !userInfo && (
          <div>Loading user information...</div>
        )} */}

      {/* {authState.isAuthenticated && userInfo && (
          <div>
            <p id="welcome">
              Welcome, &nbsp;
              {userInfo.name}!
            </p>
          </div>
        )} */}

      {/* {!authState.isAuthenticated && (
          <div>
            <Button id="login-button" primary onClick={login}>
              Login
            </Button>
          </div>
        )} */}
    </div>
  );
};

const mapStateToProps = (state, ownProps) => ({
  state: state,
});

const mapDispatchToProps = (dispatch) => ({
  incrementValue: (options) => dispatch(incrementValue(options)),
  setCurrentUserId: (options) => dispatch(setCurrentUserId(options)),
  setIsUserLoggedIn: (options) => dispatch(setIsUserLoggedIn(options)),
});

export default React.memo(connect(mapStateToProps, mapDispatchToProps)(Home));
